import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import { useForm, useFormValidation } from '../../../hooks';
import { useEditarConfiguracionNotificaciones } from '../hooks/useEditarConfiguracionNotificaciones';

import { SwitchInput } from '../../FormFields/SwitchInput';

import styles from '../Notices.module.css';

import { roles } from '../../../types/types';

export const Configuracion = ({ configuracionNotificaciones }) => {

  const [dataStatus, setDataStatus] = useState(false);

  const { user } = useSelector(state => state.auth);

  const { editarConfiguracionNotificacionesMutation: { mutate: updateConfiguracion } } = useEditarConfiguracionNotificaciones();

  const { citaNueva, citaEditada, citaPospuesta, citaConfirmada, citaCancelada, citaEliminada, alxoidAplicada, inmunoterapiaCancelada, inmunoterapiaVencida, inmunoterapiaRecogioFrasco, loginAsistente, logoutAsistente, appSolicitudVencida, appSolicitudAceptada, appSolicitudRechazada, onInputChange } = useForm({ citaNueva: configuracionNotificaciones.citaNueva, citaEditada: configuracionNotificaciones.citaEditada, citaPospuesta: configuracionNotificaciones.citaPospuesta, citaConfirmada: configuracionNotificaciones.citaConfirmada, citaCancelada: configuracionNotificaciones.citaCancelada, citaEliminada: configuracionNotificaciones.citaEliminada, alxoidAplicada: configuracionNotificaciones.alxoidAplicada, inmunoterapiaCancelada: configuracionNotificaciones.inmunoterapiaCancelada, inmunoterapiaVencida: configuracionNotificaciones.inmunoterapiaVencida, inmunoterapiaRecogioFrasco: configuracionNotificaciones.inmunoterapiaRecogioFrasco, loginAsistente: configuracionNotificaciones.loginAsistente, logoutAsistente: configuracionNotificaciones.logoutAsistente, appSolicitudVencida: configuracionNotificaciones.appSolicitudVencida, appSolicitudAceptada: configuracionNotificaciones.appSolicitudAceptada, appSolicitudRechazada: configuracionNotificaciones.appSolicitudRechazada });

  const { isFormValid, formValidationStatus, startFormValidation } = useFormValidation([{field: 'citaNueva', default: true}, {field: 'citaEditada', default: true}, {field: 'citaPospuesta', default: true}, {field: 'citaConfirmada', default: true}, {field: 'citaCancelada', default: true}, {field: 'citaEliminada', default: true}, {field: 'alxoidAplicada', default: true}, {field: 'inmunoterapiaCancelada', default: true}, {field: 'inmunoterapiaVencida', default: true}, {field: 'inmunoterapiaRecogioFrasco', default: true}, {field: 'loginAsistente', default: true}, {field: 'logoutAsistente', default: true}, {field: 'appSolicitudVencida', default: true}, {field: 'appSolicitudAceptada', default: true}, {field: 'appSolicitudRechazada', default: true}]);

  const handleChange = (e) => {
    onInputChange(e);
    setDataStatus(true);
  }

  useEffect(() => {

    if(dataStatus){

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
          updateConfiguracion({ data: { citaNueva, citaEditada, citaPospuesta, citaConfirmada, citaCancelada, citaEliminada, alxoidAplicada, inmunoterapiaCancelada, inmunoterapiaVencida, inmunoterapiaRecogioFrasco, loginAsistente, logoutAsistente, appSolicitudVencida, appSolicitudAceptada, appSolicitudRechazada } });
        }else{
          startFormValidation();
        }

    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citaNueva, citaEditada, citaPospuesta, citaConfirmada, citaCancelada, citaEliminada, alxoidAplicada, inmunoterapiaCancelada, inmunoterapiaVencida, inmunoterapiaRecogioFrasco, loginAsistente, logoutAsistente, appSolicitudVencida, appSolicitudAceptada, appSolicitudRechazada])

  return (
    <>
      <form onSubmit={() => alert('aqui')}>
        <div className="row">
          <div className="col">
            <div className={styles.catagoriaConfiguracion}>Citas</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaNueva === 'true' || citaNueva === true) ? true : false }
              label='Cita nueva'
              labelPosition='end'
              name='citaNueva'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaEditada === 'true' || citaEditada === true) ? true : false }
              label='Cita editada'
              labelPosition='end'
              name='citaEditada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaPospuesta === 'true' || citaPospuesta === true) ? true : false }
              label='Cita pospuesta'
              labelPosition='end'
              name='citaPospuesta'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaConfirmada === 'true' || citaConfirmada === true) ? true : false }
              label='Cita confirmada'
              labelPosition='end'
              name='citaConfirmada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaCancelada === 'true' || citaCancelada === true) ? true : false }
              label='Cita cancelada'
              labelPosition='end'
              name='citaCancelada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (citaEliminada === 'true' || citaEliminada === true) ? true : false }
              label='Cita eliminada'
              labelPosition='end'
              name='citaEliminada'
              onChange={handleChange}
            />
          </div>
        </div>
        {(user.rol === roles.MEDICO) && <>
        <div className="row">
          <div className="col">
            <div className={styles.catagoriaConfiguracion}>Inmunoterapias</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (alxoidAplicada === 'true' || alxoidAplicada === true) ? true : false }
              label='Alxoid aplicada'
              labelPosition='end'
              name='alxoidAplicada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (inmunoterapiaCancelada === 'true' || inmunoterapiaCancelada === true) ? true : false }
              label='Inmunoterapia cancelada'
              labelPosition='end'
              name='inmunoterapiaCancelada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (inmunoterapiaVencida === 'true' || inmunoterapiaVencida === true) ? true : false }
              label='Inmunoterapia vencida'
              labelPosition='end'
              name='inmunoterapiaVencida'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (inmunoterapiaRecogioFrasco === 'true' || inmunoterapiaRecogioFrasco === true) ? true : false }
              label='Frasco recogido'
              labelPosition='end'
              name='inmunoterapiaRecogioFrasco'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className={styles.catagoriaConfiguracion}>Asistente</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (loginAsistente === 'true' || loginAsistente === true) ? true : false }
              label='Login'
              labelPosition='end'
              name='loginAsistente'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (logoutAsistente === 'true' || logoutAsistente === true) ? true : false }
              label='Logout'
              labelPosition='end'
              name='logoutAsistente'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className={styles.catagoriaConfiguracion}>App paciente</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (appSolicitudVencida === 'true' || appSolicitudVencida === true) ? true : false }
              label='Solicitud vencida'
              labelPosition='end'
              name='appSolicitudVencida'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (appSolicitudAceptada === 'true' || appSolicitudAceptada === true) ? true : false }
              label='Solicitud aceptada'
              labelPosition='end'
              name='appSolicitudAceptada'
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <SwitchInput
              checked={ (appSolicitudRechazada === 'true' || appSolicitudRechazada === true) ? true : false }
              label='Solicitud rechazada'
              labelPosition='end'
              name='appSolicitudRechazada'
              onChange={handleChange}
            />
          </div>
        </div>
        </>}
      </form>
    </>
  )
}
